import React from 'react'

export const StepsItemContext = React.createContext<{ active: boolean; completed: boolean }>({
  active: false,
  completed: false,
})
